import { useParams } from "react-router";
import { AssignedResourcesTable } from "@/components/AssignedResourcesTable";

interface GatewayAssignment {
  gatewayId: string;
  reachable: boolean | null;
  lastCheckedAt: string | null;
  online: boolean;
}

interface ConnectorAssignment {
  connectorId: string;
  connectorName: string;
}

interface Resource {
  id: string;
  name: string;
  type: string;
  kind: string | null;
  address: string;
  port: number;
  gateways: GatewayAssignment[];
  connectors: ConnectorAssignment[];
}

export function GatewayResources() {
  const { orgId, gatewayId } = useParams();

  return (
    <AssignedResourcesTable<Resource>
      endpoint={`/organizations/${orgId}/gateways/${gatewayId}/resources`}
      emptyTitle="No resources routed through this gateway"
      emptyMessage="Assign this gateway to a resource."
      getAssignment={(resource) =>
        resource.gateways.find((g) => g.gatewayId === gatewayId)
      }
      getRoutingConnectors={(resource) =>
        resource.connectors.map((c) => ({
          id: c.connectorId,
          name: c.connectorName,
        }))
      }
    />
  );
}
